<template>
  <ui-list
    :heading="heading"
    :headings="[
      $t('labels.department.name'),
      $tc('models.building'),
      $t('misc.completion'),
      'search'
    ]"
    :sort="[
      { prop: 'name', type: false },
      { prop: 'buildingName', type: false },
      { prop: 'progress', prop2: 'progressPercentage', type: 'level2' }
    ]"
    :items="departments"
    :search_selectors="['name', 'buildingName']"
  >
    <template v-if="$slots.actions" v-slot:actions>
      <slot name="actions"></slot>
    </template>

    <template v-slot:default="props">
      <ui-list-data :text="props.item.name" :info="props.item.description">
      </ui-list-data>

      <ui-list-data type="tag" :text="props.item.building.name"> </ui-list-data>

      <!-- <ui-list-data>
        <ui-progress
          :percentage="props.item.progress.progressPercentage"
        ></ui-progress>
      </ui-list-data> -->

      <template>
        <ui-list-data-progress
          v-if="typeof getPercentage(props.item) === 'number'"
          :percentage="getPercentage(props.item)"
          :progressDetails="props.item.progress"
        >
        </ui-list-data-progress>
        <ui-list-data
          v-if="getPercentage(props.item) === false"
          :text="$t('labels.course.no_users_assigned')"
        >
        </ui-list-data>
      </template>

      <ui-list-data small>
        <auth-checker
          :accessRoles="[
            'SuperAdmin',
            'CompanyAdmin',
            'BuildingAdmin',
            'DepartmentAdmin'
          ]"
        >
          <ui-button
            type="white"
            size="small"
            uppercase
            @click="
              $router.push({
                name: 'department-show',
                params: { id: props.item.id }
              })
            "
            >{{ $tc('models.course', 2) }}</ui-button
          >
        </auth-checker>
        <auth-checker
            :accessRoles="[
            'SuperAdmin',
            'CompanyAdmin',
            'BuildingAdmin',
            'DepartmentAdmin'
          ]"
        >
          <ui-button
              type="white"
              class="ml-2"
              size="small"
              uppercase
              @click="
              $router.push({
                name: 'departments-users',
                params: { id: props.item.id }
              })
            "
          >{{ $tc('models.user', 2) }}</ui-button
          >
        </auth-checker>
        <auth-checker
          :accessRoles="['SuperAdmin', 'CompanyAdmin', 'BuildingAdmin']"
        >
          <ui-button
            class="ml-2"
            type="grey"
            size="small"
            uppercase
            @click="
              $router.push({
                name: 'departments-edit',
                params: { id: props.item.id }
              })
            "
            >{{ $t('actions.edit') }}</ui-button
          >
        </auth-checker>
      </ui-list-data>
    </template>
  </ui-list>
</template>

<script>
import UiList from '@/components/ui/UiList';
import UiListData from '@/components/ui/UiListData';
import UiListDataProgress from '@/components/ui/UiListDataProgress';
import AuthChecker from '../../auth/components/AuthChecker';
import UiButton from "@/components/ui/UiButton";

export default {
  props: {
    heading: {
      type: String
    },
    departments: {
      type: Array,
      required: true
    }
  },

  components: {
    UiButton,
    UiList,
    UiListData,
    AuthChecker,
    UiListDataProgress
  },

  methods: {
    getPercentage(item) {
      if (item.progress && item.progress.assignedCount) {
        return item.progress.progressPercentage;
      } else {
        if (item.assignedCount) {
          const per = Math.floor(
            (item.completedCount / item.assignedCount) * 100
          );
          return per;
        } else {
          return false;
        }
      }
    }
  }
};
</script>
